import { declareParams } from '@farfetched/core';
import { zodContract } from '@farfetched/zod';
import { createAuthMutation } from '../auth-http-client';
import { bonusSchema } from '../types';

export type AddBonusMutationParams = {
	currency: string;
	accountId: number;
	gameId: number;
	depositRate: number;
	activationThreshold: number;
};

export const createAddBonusMutation = () =>
	createAuthMutation({
		params: declareParams<AddBonusMutationParams>(),
		request: {
			method: 'POST',
			url: '/bonus',
			body: (data) => data,
		},
		response: {
			contract: zodContract(bonusSchema),
		},
	});
